import { ReservationDiffContainerDto, ReservationRoomBookingDiffDto, ReservationRoomBookingDiff, ReservationPosItemDiffDto, ReservationPosItemDiff } from './types';
import { ReservationProgramBookingDiffToReservationProgramBookingDiff } from './model.Programs';
import { RoomBookingToRoomBookingState } from './model.Rooms';
import { PosItemToPosItemState } from './utils';

export function ReservationDiffToReservationDiff(diff: ReservationDiffContainerDto) {
    const rooms = diff.Rooms.map(ReservationRoomBookingDiffToReservationRoomBookingDiff);
    const programs = diff.Programs.map(ReservationProgramBookingDiffToReservationProgramBookingDiff);

    // Sort rooms and programs by date to maintain chronological chain order
    rooms.sort((a, b) => a.RoomBooking.CheckIn.value.getTime() - b.RoomBooking.CheckIn.value.getTime());
    programs.sort((a, b) => a.ProgramBooking.Start.value.getTime() - b.ProgramBooking.Start.value.getTime());

    return {
        Rooms: rooms,
        Programs: programs,
        PosItems: diff.PosItems.map(pi => ReservationposItemDiffToReservationPosItemDiff(pi)),
        Transactions: diff.Transactions,
        Versions: diff.Versions,
        IsNew: diff.IsNew
    };
}

function ReservationRoomBookingDiffToReservationRoomBookingDiff(diff: ReservationRoomBookingDiffDto): ReservationRoomBookingDiff {
    return {
        RoomBooking: RoomBookingToRoomBookingState(diff.RoomBooking),
        Action: diff.Action
    };
}

function ReservationposItemDiffToReservationPosItemDiff(diff: ReservationPosItemDiffDto): ReservationPosItemDiff {
    return {
        PosItem: PosItemToPosItemState(diff.PosItem),
        Action: diff.Action
    };
}